<template>
  <div class="ElementUIS">
    <section>
      <!--ElementUI+分页+过滤+表格  -->
      <!--el-form是过滤条件  -->
      <el-form :inline="true" :model="filter" @submit.native.prevent class="inline">
        <span class="span">更多公告</span>
        <div class="link-top1"></div>
        <el-form-item label="类型" class="typelabel">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" class="time">
          <el-date-picker
            v-model="filter.publish_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="发布日期"
          ></el-date-picker>
        </el-form-item>
        <div class="link-top2"></div>
      </el-form>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="tableData.length"
        style="float:right;"
      ></el-pagination>
      <el-table
        :data="pageData"
        :row-style="{height:'20px'}"
        :cell-style="{padding:'0px'}"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :default-sort="{prop: 'data', order: 'descending'}"
        style="width: 100%;border:0;font-size: 12px;"
      >
        <el-table-column type="index" label=" "></el-table-column>
        <el-table-column prop="status" label="状态" width="80" class="stat">
          <!-- 自定义样式 -->
          <template slot-scope="scope">
            <span
              style="padding:'0px'"
              :class="addclassStatus(scope.row.status)"
            >{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noticeName" label="标题" width="450" show-overflow-tooltip></el-table-column>
        <el-table-column prop="org" label="发布组织" width="240"></el-table-column>
        <el-table-column prop="publish_time" label="发布日期" width="150">
          <template slot-scope="scope">
            <span style="padding:'0px'">{{ scope.row.publish_time.substring(0,11) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="150"></el-table-column>
        <el-table-column label="操作">
          <!-- slot-scope="scope"获取表格的数据 scope.row.type 是获取每行的参数 scope.$index 是获取下标-->
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="clickbutton(scope.row.noticeId,scope.row.type)"
              width="100"
              :style="but1"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="link-top3"></div>
      <el-button class="elbutton" type="text" plain @click="clickhref" :style="but2">返回</el-button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    let categoryInfo1 = JSON.parse(this.$supMainPageConfig).categoryInfoShow
      .resultInfo1[0];
    this.categorys = categoryInfo1.info;
    this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    this.msvalue = "全部公告";
    return {
      filter: {
        type: "",
        publish_time: ""
      },
      currentPage: 1,
      pageSize: 15,
      allData: this.categorys,
      show: true,
      showT: this.theme,
      options: [
        {
          value: "全部公告",
          label: "全部公告"
        },
        {
          value: "招标公告",
          label: "招标公告"
        },
        {
          value: "询价公告",
          label: "询价公告"
        },
        {
          value: "竞价公告",
          label: "竞价公告"
        }
      ],
      value: this.msvalue
    };
  },
  mounted() {
    //对数组根据时间降序
    this.categorys.sort(function(a, b) {
      return b["publish_time"].localeCompare(a["publish_time"]);
    });
  },
  props: ["msshow"],
  computed: {
    tableData: function() {
      return this.allData.filter(item => {
        // if (this.msshow != null) {
        //   this.value = this.msshow;
        // }

        if (this.value == "全部公告") {
          if (item.type && item.type.includes(this.value)) {
            return false;
          }
        } else {
          if (!(item.type && item.type.includes(this.value))) {
            return false;
          }
        }

        if (this.value == "全部公告") {
          if (item.type && item.type.includes(this.value)) {
            return false;
          }
        }

        if (this.filter.publish_time) {
          if (
            !(
              item.publish_time &&
              item.publish_time.includes(this.filter.publish_time)
            )
          ) {
            return false;
          }
        }
        return true;
      });
    },
    pageData: function() {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
    but1: function() {
      if (this.showT == 1) {
        return {
          color: " #4a98ff"
        };
      }
      if (this.showT == 2) {
        return {
          color: " #6869FB"
        };
      }
      if (this.showT == 3) {
        return {
          color: " #29C392"
        };
      }
      if (this.showT == 4) {
        return {
          color: " #FC8555"
        };
      }
    },
    but2: function() {
      if (this.showT == 1) {
        return {
          color: "#ffffff",
          background: "linear-gradient(90deg,#4a98ff 0%,#4a98ff 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 2) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #6869FB 0%,#6869FB 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 3) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #29C392 0%,#29C392 100%)",
          width: "100px",
          height: "40px"
        };
      }
      if (this.showT == 4) {
        return {
          color: "#ffffff",
          background: "linear-gradient( 90deg, #FC8555 0%,#FC8555 100%)",
          width: "100px",
          height: "40px"
        };
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    clickbutton(noticeId, type) {
      let param = "";
      param = "&noticeId=" + noticeId;
      const base = window.location.href.split("/isv/")[0];
      if (type == "招标公告") {
        let url = base + "/index.html?formId=ten_announcement_detail" + param;
        window.open(url, "_blank");
      } else if (type == "询价公告") {
        let url =
          base +
          "/index.html?formId=quo_notice" +
          param +
          "&noticeName=quo_inquiry";
        window.open(url, "_blank");
      } else if (type == "竞价公告") {
        let url =
          base +
          "/index.html?formId=quo_notice" +
          param +
          "&noticeName=quo_bidbill";
        window.open(url, "_blank");
      }
    },
    clicka(kurl) {
      window.open(kurl);
    },
    clickhref() {
      this.$emit("funk", this.show);
      // 退出的时候清空选择
      this.value = null;
      this.filter.publish_time = null;
      this.$forceUpdate();
      this.value = this.options[0].value;
    },
    formatter(row, column) {
      return row.publish_time;
    },
    addclassStatus(status) {
      switch (status) {
        case "招标立项":
          return "statustypea";
        case "供方入围":
          return "statustypebc";
        case "标书编制":
          return "statustypecd";
        case "发标":
          return "statustyped";
        case "答疑":
          return "statustypees";
        case "开标":
          return "statustypef";
        case "评标":
          return "statustypeg";
        case "商务谈判":
          return "statustypehs";
        case "定标":
          return "statustypei";
        case "报价中":
          return "statustype1";
        case "已开标":
          return "statustype2";
        case "已定标":
          return "statustype3";
        case "已执行":
          return "statustype4";
        case "已终止":
          return "statustype5";
        case "公告":
          return "statustype6";
        case "待报名":
          return "statustypeaa";
        case "报名中":
          return "statustypeaa";
        case "报名截止":
          return "statustypehh";
        case "已资审":
          return "statustypebb";
        case "竞价中":
          return "statustypecc";
        case "评标中":
          return "statustypedd";
        case "待执行":
          return "statustypeee";
        case "已暂停":
          return "statustypehh";
      }
    }
  }
};
</script>

<style>
.ElementUIS {
  width: 1200px;
  height: 900px;
  background-color: #ffffff;
  margin-left: 310px;
}

.inline {
  margin-top: 20px;
  margin-left: 8px;
  height: 116px;
}

.span {
  margin-right: -70px;
  font-size: 20px;
}

.typelabel {
  margin-top: 20px;
  margin-left: 4px;
}

.time {
  margin-top: 19px;
}

.elbutton {
  margin-top: 7px;
  margin-left: 45px;
  height: 37px;
}

.link-top1 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
}

.link-top2 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
}

.link-top3 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #acc0d8;
  margin-top: 10px;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f2f6fc !important;
}

.statustypea {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypebc {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypecd {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustyped {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypees {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypef {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeg {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypehs {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypei {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype1 {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype2 {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype3 {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype4 {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype5 {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustype6 {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeaa {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypebb {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypecc {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypedd {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeee {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypehh {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 10px;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

@media screen and ( max-width: 1200px ){
.ElementUI {
  width: 900px;
}
}

</style>